const ERROR_MESSAGES = {
  'Panier existe déja': 'Un panier avec ce nom existe déjà. Veuillez choisir un autre nom.',
  'Panier introuvable': 'Ce panier est introuvable.',
  'Panier n\'existe pas': 'Ce panier n\'existe pas.',
  'Impossible de supprimer ce panier': 'Impossible de supprimer ce panier.',
  'Ce produit n\'est pas disponible en stock': 'Ce produit n\'est pas disponible en stock.',
  'Ce panier n\'est pas encore une commande': 'Ce panier n\'a pas encore été validé en commande.',
  'Commande introuvable': 'Cette commande est introuvable.',
  'Cette commande n\'est pas encore traitée': 'Cette commande n\'est pas encore traitée.',
  'Cart not found': 'Panier introuvable.',
  'Product not found': 'Produit introuvable.',
  'Accès non autorisé': 'Vous n\'êtes pas autorisé à effectuer cette action.',
  'Accès refusé': 'Accès refusé.',
  'Facture introuvable': 'Cette facture est introuvable.',
  'La facture n\'existe pas': 'Cette facture n\'existe pas.',
  'Règlement introuvable': 'Ce règlement est introuvable.',
  'Document introuvable': 'Ce document est introuvable.',
  'Attestation non disponible': 'Cette attestation n\'est pas disponible.',
  'Mot de passe erroné': 'Mot de passe incorrect.',
  'Le moyen d\'expédition n\'existe pas': 'Le mode de transport sélectionné n\'existe pas.',
  'Le commercial n\'existe pas': 'Le commercial associé est introuvable.',
  'Le compte client n\'existe pas': 'Ce compte client n\'existe pas.',
  'le code client n\'existe pas': 'Ce code client n\'existe pas.',
  'L\'annonce n\'existe pas': 'Cette annonce est introuvable.',
  'Vous devez vous présenter au salon pour bénéficier de la remise': 'Vous devez vous présenter au salon pour bénéficier de la remise salon.',
  'Aucune facture trouvée pour les critères sélectionnés.': 'Aucune facture trouvée pour les critères sélectionnés.',
  'File not supported': 'Format de fichier non supporté.',
  'Internal Exception': 'Une erreur interne est survenue, veuillez réessayer.',
};

const formatErrorMessage = (msg) => ERROR_MESSAGES[msg] || msg;

export default formatErrorMessage;
